import Vue from 'vue'

Vue.filter('dateFilter', function (value, pattern) {
  const _formatDate = function (date, pattern) {
    pattern = pattern || 'yyyy/MM/dd'
    const y = date.getFullYear().toString()
    const o = {
      M: date.getMonth() + 1, // month
      d: date.getDate(), // day
      h: date.getHours(), // hour
      m: date.getMinutes(), // minute
      s: date.getSeconds() // second
    }
    pattern = pattern.replace(/(y+)/ig, function (a, b) {
      return y.substr(4 - Math.min(4, b.length))
    })
    for (const i in o) {
      pattern = pattern.replace(new RegExp(`(${i}+)`, 'g'), function (a, b) {
        return (o[i] < 10 && b.length > 1) ? `0${o[i]}` : o[i]
      })
    }
    return pattern
  }

  return _formatDate(value, pattern)
})

// Setting - 转化类型
Vue.filter('transTypeFilter', function (value) {
  const types = {
    '1': '页面转化',
    '2': '事件转化',
    '3': '时长转化',
    '4': '页数转化'
  }
  return types[value]
})

// Setting - 点睛账号绑定状态
Vue.filter('bstatusFilter', function (value) {
  const types = {
    '0': '校验中', // "未绑定",
    '1': '已绑定',
    '2': '已拒绝'
  }
  return types[value]
})

Vue.filter('percent', function (value) {
  if (isNaN(Number(value))) {
    return value
  }

  return `${parseFloat((value * 100).toFixed(2))}%`
})

Vue.filter('httpUrl', function (value) {
  return /^(https?:)?\/\//.test(value) ? value : `http://${value}`
})

const secToTime = function (secs) {
  if (secs === '' || secs === void 0) return ''
  const hours = Math.floor(secs / 3600)
  const minutes = Math.floor((secs - hours * 3600) / 60)
  secs = secs % 60
  let ret = `${`0${minutes}`.slice(-2)}:${`0${secs}`.slice(-2)}`
  ret = `${hours}`.length === 1 ? `0${hours}:${ret}` : `${hours}:${ret}`
  return ret
}
Vue.filter('secToTime', secToTime)

// atime
Vue.filter('transAtime', function (value, field = '') {
  if (/atime/.test(field)) {
    return secToTime(value)
  }
  return value
})

Vue.filter('ellipsis', function (value, len) {
  return value.length > len ? `${value.slice(0, len)}...` : value
})



// WEBPACK FOOTER //
// ./src/script/filter.js